export default __webpack_public_path__ + "static/media/headset_24px.6c78f660.svg";